import { CostFragment } from "@shared/apollo/fragments";
import gql from "graphql-tag";

export const CREATE_COST_MUTATION = gql`
  mutation createCost($appraisalId: String!, $cost: CostInput!) {
    createCost(appraisalId: $appraisalId, cost: $cost) {
      ...Cost
    }
  }
  ${CostFragment}
`;

export const UPDATE_COSTS_MUTATION = gql`
  mutation updateCosts($appraisalId: String!, $costs: [CostInput!]!) {
    updateCosts(appraisalId: $appraisalId, costs: $costs) {
      ...Cost
    }
  }
  ${CostFragment}
`;

export const DELETE_COST_MUTATION = gql`
  mutation deleteCost($appraisalId: String!, $id: String!) {
    deleteCost(appraisalId: $appraisalId, id: $id)
  }
`;
